import React from "react";
import { VariableLookupText } from "~/components/form/VariableLookupText";
import type { FormFieldProps } from "~/components/form/index";
interface MultiLineTextInputProps extends FormFieldProps<string> {
    label: string;
    localNames?: string[];
    warning?: string;
    defaultValueIndicator: JSX.Element | undefined;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
    monoSpacedFont?: boolean;
    autoFocus?: boolean;
}
const MultiLineTextInput: React.FC<MultiLineTextInputProps> = (props) => {
    const { value, label, localNames, warning, defaultValueIndicator, monoSpacedFont, ...rest } = props;
    const formProps = { ...rest, label };
    return (<React.Fragment>
            <VariableLookupText value={value} localNames={localNames} warning={warning} multiline={true} monoSpacedFont={monoSpacedFont} {...formProps}/>
            {defaultValueIndicator}
        </React.Fragment>);
};
MultiLineTextInput.displayName = "MultiLineTextInput"
export default MultiLineTextInput;
